import { Component, EventEmitter, Output, HostListener, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { InspectionService } from '../inspection.service';

@Component({
  selector: 'app-add-scheduling-note',
  templateUrl: './add-scheduling-note.component.html',
  styleUrls: ['./add-scheduling-note.component.scss'],
})
export class AddSchedulingNoteComponent {
  @Output() closeModal = new EventEmitter<void>();
  @Output() saveNote = new EventEmitter<any>();
  @Output() noteCreated = new EventEmitter<any>();

  @Input() inspectionId: number;

  form: FormGroup;
  showReasonDropdown = false;
  selectedReason = '';
  isSaving = false;

  reasons = ['General', 'Contact Issues', 'Status', 'Appointment Scheduled'];

  constructor(
    private fb: FormBuilder,
    private inspectionService: InspectionService,
  ) {
    this.form = this.fb.group({
      reason: ['', Validators.required],
      note: ['', Validators.required],
    });
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    // Close dropdown if clicking outside
    const target = event.target as HTMLElement;
    if (!target.closest('.dropdown-container') && !target.closest('.dropdown-options')) {
      this.showReasonDropdown = false;
    }
  }

  toggleReasonDropdown() {
    this.showReasonDropdown = !this.showReasonDropdown;
  }

  selectReason(reason: string) {
    this.selectedReason = reason;
    this.form.patchValue({ reason });
    this.showReasonDropdown = false;
  }

  onCancel() {
    this.closeModal.emit();
  }

  async onSave() {
    if (this.isSaving || this.form.invalid) return;
    this.isSaving = true;
    try {
      const formData = {
        reason: this.form.get('reason')?.value,
        content: this.form.get('note')?.value,
      };

      const createdNote = await this.inspectionService.createNote(this.inspectionId, formData);
      this.noteCreated.emit(createdNote);
      this.closeModal.emit();

      this.form.reset();
      this.selectedReason = '';
    } catch (error) {
      console.error('Error creating note:', error);
    } finally {
      this.isSaving = false;
    }
  }

  onTextareaInput(event: Event) {
    const textarea = event.target as HTMLTextAreaElement;
    textarea.style.height = 'auto';
    textarea.style.height = textarea.scrollHeight + 'px';
  }
}
